import { FitnessLevelsEnum } from "../../Types/Enums/FitnessEnums";

export const FITNESS_MAP = [
  { id: FitnessLevelsEnum.SEDENTARY, labels: { 0: "Sedentario", 1: "Sedentary" } },
  { id: FitnessLevelsEnum.LIGHT, labels: { 0: "Ligeramente Activo", 1: "Lightly Active" } },
  { id: FitnessLevelsEnum.ACTIVE, labels: { 0: "Moderadamente Activo", 1: "Moderately Active" } },
  { id: FitnessLevelsEnum.VERY_ACTIVE, labels: { 0: "Muy Activo", 1: "Very Active" } },
  { id: FitnessLevelsEnum.ATHLETE, labels: { 0: "Atleta", 1: "Athlete" } },
];